export enum BrowserKinds {
  Unknown = 0,
  InternetExplorer = 1,
  MicrosoftEdge = 2,
  GoogleChrome = 3,
  Safari = 4,
  MozillaFirefox = 5,
  Opera = 6,
  ChromiumEdge = 7,
}

export class BrowserUtility {
  static getBrowserKind(): BrowserKinds {
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf("msie") !== -1 || userAgent.indexOf("trident") !== -1) {
      return BrowserKinds.InternetExplorer;
    } else if (userAgent.indexOf("edge") !== -1) {
      return BrowserKinds.MicrosoftEdge;
    } else if (userAgent.indexOf("edg") !== -1) {
      return BrowserKinds.ChromiumEdge;
    } else if (userAgent.indexOf("chrome") !== -1) {
      return BrowserKinds.GoogleChrome;
    } else if (userAgent.indexOf("safari") !== -1) {
      return BrowserKinds.Safari;
    } else if (userAgent.indexOf("firefox") !== -1) {
      return BrowserKinds.MozillaFirefox;
    } else if (userAgent.indexOf("opera") !== -1) {
      return BrowserKinds.Opera;
    } else {
      return BrowserKinds.Unknown;
    }
  }

  static isMobile(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    return !!userAgent.match(/(iphone)|(ipad)|(ipod)|(android)/)
        || !!(userAgent.match(/macintosh/) && userAgent.match(/safari/) && "ontouchend" in document); // iPadのSafari「デスクトップ用Webサイトを表示」On(OS13以降の既定値)設定時)
  }

  static isChromiumBrowser(): boolean {
    const browserKind = BrowserUtility.getBrowserKind();
    return ((browserKind === BrowserKinds.GoogleChrome) || (browserKind === BrowserKinds.ChromiumEdge));
  }

  static isTouchSupported(): boolean {
    return (
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      window.matchMedia("(pointer:coarse)").matches
    );
  }
}
